import React from 'react';
import { motion } from 'framer-motion';
import { useTheme } from '../context/ThemeContext';

const TermsAndConditions: React.FC = () => {
  const { themeConfig } = useTheme();

  const sections = [
    {
      title: '1. Acceptance of Terms',
      content: `By accessing and using this website and engaging my freelance services, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.`,
    },
    {
      title: '2. Service Description',
      content: `I provide freelance software development services specializing in:
      • AI/ML Development and Consulting
      • Python Development and Automation
      • Data Science and Analytics
      • Computer Vision Solutions
      • Web Scraping and Data Extraction
      • Custom Software Development`,
    },
    {
      title: '3. Project Scope and Deliverables',
      content: `All project requirements, timelines, and deliverables will be clearly defined before project commencement. Any changes to the original scope must be agreed upon in writing and may result in additional charges.`,
    },
    {
      title: '4. Payment Terms',
      content: `• Payment terms will be agreed upon before project start
      • Upwork projects follow Upwork's payment protection policies
      • Direct projects require 50% upfront payment for projects over $500
      • Final payment due upon project completion and delivery
      • Refunds available only in case of non-delivery as per agreed terms`,
    },
    {
      title: '5. Intellectual Property',
      content: `Upon full payment, you will own the custom code developed specifically for your project. However, I retain the right to use general methodologies, techniques, and non-proprietary code in future projects. Any pre-existing code or libraries remain under their original licenses.`,
    },
    {
      title: '6. Confidentiality',
      content: `I maintain strict confidentiality regarding all client projects and data. Non-disclosure agreements can be signed upon request for sensitive projects.`,
    },
    {
      title: '7. Limitation of Liability',
      content: `My liability is limited to the amount paid for the specific project. I am not liable for any indirect, incidental, or consequential damages arising from the use of delivered software.`,
    },
    {
      title: '8. Project Timeline',
      content: `Project timelines are estimates based on the information provided. Delays due to changes in requirements, late feedback, or external dependencies may affect delivery dates.`,
    },
    {
      title: '9. Support and Maintenance',
      content: `Basic support (bug fixes) is provided for 30 days after project delivery. Extended support and maintenance can be arranged separately.`,
    },
    {
      title: '10. Communication',
      content: `Primary communication will be through agreed channels (email, Upwork, or project management tools). I aim to respond within 24 hours during business days.`,
    },
    {
      title: '11. Termination',
      content: `Either party may terminate the project with written notice. Payment for completed work will be due upon termination.`,
    },
    {
      title: '12. Governing Law',
      content: `These terms shall be governed by and construed in accordance with the laws of India. Any disputes will be resolved through arbitration in New Delhi, India.`,
    },
  ];

  return (
    <div className="min-h-screen">
      <section className={`${themeConfig.layout?.sectionStyle}`}>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="text-4xl font-bold mb-6 text-[var(--color-primary)]">Terms and Conditions</h1>
          <p className="text-lg mb-8 text-[var(--color-text)] opacity-80">
            Last updated: September 2, 2025
          </p>
          
          <div className="prose max-w-none">
            <p className="text-[var(--color-text)] opacity-80 mb-8">
              These terms and conditions outline the rules and regulations for the use of Chaitanya Sharma's 
              freelance services and website.
            </p>

            <div className="space-y-8">
              {sections.map((section, idx) => (
                <motion.div
                  key={idx}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: idx * 0.1 }}
                  viewport={{ once: true }}
                  className="p-6 rounded-lg border border-[var(--color-secondary)]"
                >
                  <h3 className="text-xl font-semibold mb-4 text-[var(--color-primary)]">
                    {section.title}
                  </h3>
                  <div className="text-[var(--color-text)] opacity-80 whitespace-pre-line">
                    {section.content}
                  </div>
                </motion.div>
              ))}
            </div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="mt-12 p-6 rounded-lg bg-[var(--color-secondary)] bg-opacity-20"
            >
              <h3 className="text-xl font-semibold mb-4 text-[var(--color-primary)]">Contact Information</h3>
              <p className="text-[var(--color-text)] opacity-80 mb-4">
                If you have any questions about these Terms and Conditions, please contact me:
              </p>
              <div className="space-y-2 text-[var(--color-text)] opacity-80">
                <p>📧 Email: sharmachaitanya945@gmail.com</p>
                <p>📞 Phone: +91-8750539794</p>
                <p>🌐 Website: https://sharmachaitanya945.com</p>
                <p>💼 Upwork: https://www.upwork.com/freelancers/~01f16adc9d2f50d399</p>
              </div>
            </motion.div>
          </div>
        </motion.div>
      </section>
    </div>
  );
};

export default TermsAndConditions;
